import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Rocket } from "lucide-react";
import { toast } from "sonner";
import BrandHeader from "@/components/BrandHeader";
import Landing from "@/components/Landing";
import Wizard from "@/components/Wizard";
import Footer from "@/components/Footer";
import { fetchTableau, createAssessment } from "@/lib/apiClient";

const LoadingScreen = () => (
  <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
    <motion.div
      animate={{ y: [0, -10, 0] }}
      transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }}
    >
      <Rocket className="h-12 w-12 text-brand-orange" />
    </motion.div>
    <h2 className="mt-8 font-display uppercase text-2xl tracking-tight text-white">
      Ihr Lagebericht wird erstellt
    </h2>
    <p className="mt-3 text-sm text-white/50 max-w-md">
      Wir werten Ihre Antworten aus, vergleichen mit dem Benchmark und formulieren Ihre
      konkreten nächsten Schritte. Einen Moment.
    </p>
    <Loader2 className="mt-8 h-5 w-5 animate-spin text-brand-orange" />
  </div>
);

export default function AssessmentFlow() {
  const navigate = useNavigate();
  const [phase, setPhase] = useState("landing"); // landing | wizard | loading
  const [tableau, setTableau] = useState(null);
  const [loading, setLoading] = useState(true);
  const [answers, setAnswers] = useState({});
  const [branche, setBranche] = useState("allgemein");

  useEffect(() => {
    fetchTableau()
      .then(setTableau)
      .catch(() => toast.error("Tableau konnte nicht geladen werden."))
      .finally(() => setLoading(false));
  }, []);

  const setAnswer = (hfId, note) => setAnswers((a) => ({ ...a, [hfId]: note }));

  const handleComplete = async () => {
    setPhase("loading");
    window.scrollTo({ top: 0 });
    try {
      const result = await createAssessment({ answers, branche });
      navigate(`/ergebnis/${result.id}`, { state: { result } });
    } catch (e) {
      toast.error("Lagebericht konnte nicht erstellt werden. Bitte erneut versuchen.");
      setPhase("wizard");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-brand-orange" />
      </div>
    );
  }

  return (
    <div className="min-h-screen relative z-10">
      <BrandHeader />
      {phase === "landing" && <Landing onStart={() => setPhase("wizard")} />}      {phase === "wizard" && tableau && (
        <Wizard
          fields={tableau.handlungsfelder}
          branchen={tableau.branchen}
          branche={branche}
          setBranche={setBranche}
          answers={answers}
          setAnswer={setAnswer}
          onComplete={handleComplete}
          onBackToStart={() => setPhase("landing")}
        />
      )}
      {phase === "loading" && <LoadingScreen />}
      {phase === "landing" && <Footer />}
    </div>
  );
}
